import styled, { keyframes } from "styled-components";
import { ReactComponent as LoadingSpinner } from "../../assets/svg/loadingSpinner.svg";
import { TextField } from "@mui/material";

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: opacity 300ms ease-in-out, visibility 300ms ease-in-out;
`;

export const FormContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 3rem 2rem 2rem 2rem;
  max-width: 350px; // consistent and visually balanced
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 8px;
  padding: 25px 30px;
  transform: translateY(-50%);
  opacity: 0;
  transition: transform 300ms ease-in-out, opacity 300ms ease-in-out;
  margin: auto;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  &:hover {
    opacity: 0.8;
  }
`;

export const Title = styled.p`
  text-align: center;
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
  margin: 10px 0 30px 0;
  font-size: 28px;
  font-weight: 800;
`;
export const Description = styled.p`
  text-align: center;
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
  margin: 10px 0 30px 0;
  font-size: 13px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  margin-top: 15px;
`;

export const Input = styled.input`
  border-radius: 6px;
  border: 1px solid #c0c0c0;
  outline: none;
  padding: 12px 15px;
  width: 100%;
  box-sizing: border-box;
`;

export const PageLink = styled.p`
  text-decoration: underline;
  margin: 0;
  text-align: end;
  color: #747474;
  text-decoration-color: #747474;
  font-size: 9px;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    color: #000;
  }
`;

export const Button = styled.button`
  padding: 0 12px;
  min-height: 44px;
  border-radius: 6px;
  width: 100%;
  background: #2563eb; /* 🔵 updated to blue */
  color: white;
  font-weight: 600;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  border: none;

  &:active {
    box-shadow: none;
  }
  &:hover {
    background-color: #1d4ed8;
  }
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const SignUpLabel = styled.p`
  font-size: 10px;
  color: #747474;
  margin: 0;
`;

export const SignUpLink = styled.span`
  font-size: 11px;
  text-decoration: underline;
  text-decoration-color: teal;
  color: teal;
  cursor: pointer;
  font-weight: 800;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;
`;

export const SocialButton = styled.div`
  width: 100%;
  padding: 10px 15px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  gap: 8px;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 10px;
`;

export const AppleButton = styled(SocialButton)`
  background-color: #000;
  color: #fff;
  border: 2px solid #000;
`;

export const GoogleButton = styled(SocialButton)`
  border: 2px solid #747474;
  font-size: 15px;
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled(LoadingSpinner)`
  animation: ${spin} 2s linear infinite;
  align-self: center;
`;
export const Field = styled(TextField)`
  width: 100%;
  margin-bottom: 1.5rem;
  .MuiOutlinedInput-root {
    height: 44px; /* 👈 Thinner height */
    font-size: 0.9rem;
    padding: 0 12px;
  }

  .MuiInputBase-input {
    padding: 12px 14px;
  }

  .MuiInputLabel-root {
    font-size: 0.85rem;
    transform: translate(14px, 14px) scale(1);
    transition: all 0.2s ease;
  }

  .MuiInputLabel-shrink {
    transform: translate(14px, -9px) scale(0.75); /* 👈 Floating effect */
  }

  .MuiFormHelperText-root {
    margin-left: 0;
    font-size: 0.75rem;
  }
`;

export const FieldWrapper = styled.div`
  margin-bottom: 1.5rem;
`;
export const IconWrapper = styled.div`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 20px;
  cursor: pointer;
`;
export const ClickableIconWrapper = styled(IconWrapper)`
  cursor: pointer;
  &:hover {
    color: #2563eb;
  }
`;
